var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1594_9396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1594_9396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 28L16.0007 2.66663L30.6673 28H1.33398ZM5.93398 25.3333H26.0673L16.0007 7.99996L5.93398 25.3333ZM16.0007 24C16.3784 24 16.6951 23.8722 16.9507 23.6166C17.2062 23.3611 17.334 23.0444 17.334 22.6666C17.334 22.2888 17.2062 21.9722 16.9507 21.7166C16.6951 21.4611 16.3784 21.3333 16.0007 21.3333C15.6229 21.3333 15.3062 21.4611 15.0507 21.7166C14.7951 21.9722 14.6673 22.2888 14.6673 22.6666C14.6673 23.0444 14.7951 23.3611 15.0507 23.6166C15.3062 23.8722 15.6229 24 16.0007 24ZM14.6673 20H17.334V13.3333H14.6673V20Z",
    fill: "#7A760E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d6c689666b68db8905acd3cf686dc549.svg";
export { ForwardRef as ReactComponent };